import {Box, Collapse, IconButton, Stack, Text, Tile} from "@mbank-design/design-system/components";
import SelectedSlots from "./SelectedSlots";
import {ChevronDown} from "@mbank-design/design-system/icons";
import {IconButtonType, Spacing} from "@mbank-design/design-system/enums";
import moment from "moment/moment";
import React, {useContext, useState} from "react";
import {SpeakerInvitationDay} from "../../../model/SpeakerInvitationCreateMessage";
import DaySlots from "./DaySlots";
import Participation from "./Participation";
import {ParticipationType} from "../../../model/ParticipationType";
import {InvitationDatesContext} from "./InvitationDatesContext";
import {ValidationContext} from "../SpeakerInvitationValidation";

interface DayProps {
    day: SpeakerInvitationDay,
    selectedDate: Date | undefined,
    onSelectedDayChanged: ((date: Date | undefined) => void);
}

export default function Day({day, selectedDate, onSelectedDayChanged}: DayProps) {
    const {onSlotChange, onParticipationTypeChange} = useContext(InvitationDatesContext);
    const validationState = useContext(ValidationContext);
    
    const collapsed = selectedDate === day.date;
    
    const onCollapsedChange = () => {
        const newCollapsedState = !collapsed;
        if (newCollapsedState) {
            onSelectedDayChanged(day.date);
        } else {
            onSelectedDayChanged(undefined);
        }
    }
    
    const isDayValid = validationState.invalidDates.filter(d => d.date === day.date).length <= 0;
        
    
    return (
        <Tile>
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"flex-start"} padding={16} width={"100%"}>
                <Stack>
                    <SelectedSlots slots={day.slots} participationType={day.participationType} isDayValid={isDayValid} />
                    <Box>
                        {day.participationType === ParticipationType.NotParticipate
                            ? <span className={"text-line-through"}><Text as={"h4"} color={"doveGrayUI"}>{moment(day.date).format("DD.MM.yyyy dddd")}</Text></span>
                            : <Text as={"h4"}>{moment(day.date).format("DD.MM.yyyy dddd")}</Text>
                        }
                    </Box>
                    
                </Stack>
                <Box display={"flex"} alignItems={"center"}>
                    <IconButton iconComponent={ChevronDown} buttonType={IconButtonType.TRANSPARENT} iconSize={24} onClick={() => onCollapsedChange()} />
                </Box>
            </Box>

            <Collapse in={collapsed} timeout={300}>
                <Box width={"100%"} padding={16}>
                    <Stack>
                        <Participation participationType={day.participationType} allowedParticipationType={day.allowedParticipationType} onParticipationTypeChange={(participationType: ParticipationType) => onParticipationTypeChange ? onParticipationTypeChange(day.date, participationType) : console.error('onParticipationTypeChange should not be empty!')}/>
                        <DaySlots slots={day.slots} onSlotChange={(uiId)  => onSlotChange ? onSlotChange(day.date, uiId) : console.error('onSlotChange should not be empty!')}/>
                    </Stack>
                </Box>
            </Collapse>

        </Tile>
    );
}